import { r as AjvJsonSchemaValidator } from "./src-IKPjmxu7.mjs";
import process from "node:process";

export { AjvJsonSchemaValidator as DefaultJsonSchemaValidator, process };